import { 
    FieldBtn
} from './dues.style';
import React, { useRef } from 'react'
import { Button, Dialog, Heading, Pane, Spinner, TextareaField, toaster } from 'evergreen-ui';
import {
    AppInputField,InputFieldTitleText,AppInputFieldSelect, AppInputFieldBtnCancel, AppInputFieldBtn
} from './../../../../widget/styledComponents/input_field.style'
import { gql, useMutation, useQuery } from '@apollo/client';
import Cookies from 'js-cookie';
import { useState } from 'react';
import SelectBankAccount from './widgets/select_bank';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';


export const DUE_CREATE= gql`
mutation Due_create($facilityId: ID!, $properties: [ID!]!, $appliesToAllProperties: Boolean!, $title: String!, $defaultAmount: Float!, $startDate: Date!, $endDate: Date!, $paymentConfiguration: [DuePaymentConfigurationInput!]!, $paymentFrequency: DuePaymentFrequency!, $payerType: DuePayerType!, $description: String) {
  due_create(facilityId: $facilityId, properties: $properties, appliesToAllProperties: $appliesToAllProperties, title: $title, defaultAmount: $defaultAmount, startDate: $startDate, endDate: $endDate, paymentConfiguration: $paymentConfiguration, paymentFrequency: $paymentFrequency, payerType: $payerType, description: $description) {
    code
    success
    error
    data {
      _id
    }
  }
}
`;


export const DUE_CREATION_CONFIRMALLPROPHAVERES= gql`
query Due_creation_confirmIfAllPropertiesHaveResident($facilityId: ID!, $properties: [ID!]!, $appliesToAllProperties: Boolean!) {
  due_creation_confirmIfAllPropertiesHaveResident(facilityId: $facilityId, properties: $properties, appliesToAllProperties: $appliesToAllProperties) {
    allPropertiesHasResident
    propertiesWithoutResident {
      numberOfRooms
      _id
      facility
    }
    propertiesWithoutResidentCount
  }
}
`;


export const DUE_CREATION_PROPERTY_CONFIG= gql`
query Due_creation_getPropertiesConfiguration($facilityId: ID!, $properties: [ID!]!, $appliesToAllProperties: Boolean!) {
  due_creation_getPropertiesConfiguration(facilityId: $facilityId, properties: $properties, appliesToAllProperties: $appliesToAllProperties) {
    type
    numberOfRooms
  }
}
`;

 
export default function AddDuesButton() {
const [isShown, setIsShown] = React.useState(false)
const facilityId = Cookies.get('facilityId');
const [paymentConfigStage,setPaymentConfiState] = useState(false)
const [dataToSend,setDataToSend] = useState(null)
const [selectedBank, setSelectedBank] = useState(null)

const handleSubmit=(e)=>{
    e.preventDefault()
    const val1 = amountRef.current.value.trim();
    const datoToSendd= {
        facilityId: facilityId,
        properties: [],
        appliesToAllProperties: true,
        title: titleRef.current.value,
        defaultAmount:val1,
        startDate: startDateRef.current.value,
        endDate:  endDateRef.current.value,
        paymentConfiguration:[],
        paymentFrequency: paymentFreqRef.current.value,
        payerType:payerRef.current.value,
        description:descriptionRef.current.value,
        bankAccountId:selectedBank
    }

    console.log(datoToSendd)
    if(selectedBank ===null){
        toaster.danger("Select a bank to attach to this due you are about to create")
    }else{
        setDataToSend(datoToSendd)
        setPaymentConfiState(true);
    }
    
}

const titleRef = useRef(null);
const amountRef = useRef(null);
const startDateRef = useRef(null);
const endDateRef = useRef(null);
const paymentFreqRef = useRef(null);
const payerRef = useRef(null);
const descriptionRef = useRef(null);



const handleBankSelect = (value) => {
    console.log(value)
    setSelectedBank(value)
    console.log(selectedBank)
};


    return (
        <div>
            <Dialog
            isShown={isShown}
            title="Create a Due"
            onCloseComplete={() =>console.log("add")}
            onCancel={() => setIsShown(false)}
            shouldCloseOnOverlayClick={false}
            confirmLabel="Add"
            // onSubmit={handleSubmit}
            onConfirm={handleSubmit}
            hasFooter={false}
            hasHeader={true}
            >
               
                {!paymentConfigStage  &&
                <form onSubmit={handleSubmit}>
                    <div className='row'>
                        <div className='col s12 '>
                            <InputFieldTitleText>
                                Title
                            </InputFieldTitleText>
                            <AppInputField
                                type="text" 
                                ref={titleRef}
                                placholder="alijames@gmail.com"
                            required/> 
                        </div>
                        <div className='col s12 '>
                            <InputFieldTitleText>
                                Amount
                            </InputFieldTitleText>
                            <AppInputField
                                type="number" step="0.01"
                                // type="text" 
                                ref={amountRef}
                                placholder="alijames@gmail.com"
                            required/> 
                        </div>
                        <div className='col s12 '>
                            <InputFieldTitleText>
                            Who’s paying
                            </InputFieldTitleText>
                            <AppInputFieldSelect
                                ref={payerRef}
                                className="browser-default" required>
                                <option value="" disabled selected>Choose your option</option>
                                <option value="owner">Owners Only</option>
                                <option value="resident_or_owner">Residents Or Owners</option>
                            </AppInputFieldSelect>
                        </div>
                        <div className='col s12'>
                            <InputFieldTitleText>
                                Select bank account for due
                            </InputFieldTitleText>
                            <SelectBankAccount onSelect={handleBankSelect}/>
                        </div>
                        <div className='col s12 '>
                            <InputFieldTitleText>
                            Start Date
                            </InputFieldTitleText>
                            <AppInputField
                                type="datetime-local" 
                                ref={startDateRef}
                                placholder="alijames@gmail.com"
                            required/> 
                        </div>
                        <div className='col s12 '>
                            <InputFieldTitleText>
                            End Date
                            </InputFieldTitleText>
                            <AppInputField
                                type="datetime-local" 
                                ref={endDateRef}
                                placholder="Pick A start data"
                            required/> 
                        </div>
                        <div className='col s12 '>
                            <InputFieldTitleText>
                            Payment frequency
                            </InputFieldTitleText>
                            <AppInputFieldSelect
                                ref={paymentFreqRef}
                                className="browser-default" required>
                                <option value="" disabled selected>Choose your option</option>
                                <option value="Monthly">Monthly</option>
                                <option value="Weekly">Weekly</option>
                                <option value="Yearly">Yearly</option>
                                <option value="None">Once</option>

                                
                            </AppInputFieldSelect>
                        </div>

                        <div className='col s12 '>
                            <InputFieldTitleText>
                                Description
                            </InputFieldTitleText>
                            <Pane>
                                <TextareaField
                                id="textarea-2" 
                                placeholder="Textarea placeholder..." 
                                inputHeight={"150px"}
                                ref={descriptionRef}
                                />
                            </Pane>
                        </div>

                        

                        <div className='col s12 right mt-50' style={{
                            display:"flex",
                            flexWrap:"wrap",
                            justifyContent:"end"
                        }}>
                        <AppInputFieldBtn className=''>
                            Add
                        </AppInputFieldBtn>
                        <AppInputFieldBtnCancel 
                            onClick={()=>setIsShown(false)}
                        >
                            Cancel
                        </AppInputFieldBtnCancel >
                        </div>
                    </div>
                </form>
                }

                {paymentConfigStage &&
                    <PaymentConfigurationBreakdown dataToSend={dataToSend}/>
                }

            </Dialog>
            <FieldBtn onClick={() => setIsShown(true)} class="waves-effect waves-light btn-flat ">
                    <i class="material-icons left">add</i>
                    Collect dues
            </FieldBtn>

        </div>
        
    )
}







function PaymentConfigurationBreakdown(props) {
const dataToSend = props.dataToSend;
const facilityId = Cookies.get('facilityId');


const [confirmPaymentConfig,setConfirmPaymentConfig]= useState(false)

const {loading,error,data }   = useQuery(DUE_CREATION_CONFIRMALLPROPHAVERES,{
    variables: {
        facilityId:facilityId,
        properties: [],
        appliesToAllProperties: true,
     },
});

if (loading) return <Spinner/>;
if (error) return <p>Error: {error.message}</p>;
const res = data.due_creation_confirmIfAllPropertiesHaveResident

  return (
    <div>
        <div className=''>
            {!confirmPaymentConfig &&
                <div>
                    <p className='mb-25'>
                        There are <b>{res.propertiesWithoutResidentCount}</b> properties with no resident.
                    </p>
                    <div className='mb-25' style={{
                        display:"flex",
                        justifyContent:"space-between",
                        flexWrap:"wrap"

                    }}>
                        <Button
                            margin={8} 
                            appearance="primary"
                            
                        >
                            Exclude Properties
                        </Button>
                        <Button margin={8} appearance="primary" 
                            onClick={()=>setConfirmPaymentConfig(true)}
                        >
                            View Properties
                        </Button>
                        <Button margin={8}
                            appearance="primary"
                            onClick={()=>setConfirmPaymentConfig(true)}
                        >
                            Continue
                        </Button>
                    </div>

                </div>
            }

            {confirmPaymentConfig &&
                <ConfirmPaymentConfiguration dataToSend={{
                    intialData:dataToSend,
                    propertiesWithNoResident:res
                }}/>
            }
        </div>

    </div>
  )
}




function ConfirmPaymentConfiguration(props) {
const facilityId = Cookies.get('facilityId');
const {loading,error,data }   = useQuery(DUE_CREATION_PROPERTY_CONFIG,{
    variables: {
        facilityId:facilityId,
        properties: [],
        appliesToAllProperties: true,
    },
});

const dataToSend = props.dataToSend.intialData;
console.log(dataToSend.defaultAmount)

if (loading) return <Spinner/>;
if (error) return <p>Error: {error.message}</p>;
const propty = data.due_creation_getPropertiesConfiguration




const updatedArray = propty.map(item => {
// Update the object data here
var amount =parseFloat(dataToSend.defaultAmount);
return {
    // ...item,
    type:item.type,
    numberOfRooms:item.numberOfRooms,
    amount:amount
};
});
console.log(updatedArray)






  return (
    <div>
        <Pane display="flex" paddingTop={10} borderRadius={3}>
            <Pane 
                // background="tint2" 
                flex={1}  
                alignItems="center" 
                display="flex" 
                justifyContent="space-between"
                height="50px"
            >
                <Heading size={500}>Property Type</Heading>
                <Heading size={500}>No of Rooms</Heading>
            </Pane>
            <Pane paddingLeft={16}
                paddingTop={16}
                alignItems="center" 
                height="50px"
                style={{
                    width:"100px"
                }}>
               <Heading size={500}>Amount</Heading>
                    
            </Pane>
         
        </Pane>

       

        <ProprtyAvailableForListWidgetDues initialValues={updatedArray} />
<br/>                                
                <div className='col s12 right' style={{
                    display:"flex",
                    flexWrap:"wrap",
                    justifyContent:"end"
                }}>
                    
                    <div className='' style={{
                        width:"100px",
                        padding:"16px "
                    }}>
                        <AppInputFieldBtnCancel 
                        onClick={()=> window.location.reload()}
                    >
                            Cancel
                        </AppInputFieldBtnCancel >
                    </div>
                    <div className='' style={{
                        width:"120px",
                        padding:"16px 0px 16px 16px "
                    }}>
                        <AddDuesSubmitButton 
                                dataTo={{
                                facilityId: facilityId,
                                properties: [],
                                appliesToAllProperties: true,
                                title: dataToSend.title,
                                defaultAmount:parseFloat(dataToSend.defaultAmount),
                                startDate: dataToSend.startDate,
                                endDate:   dataToSend.endDate,
                                paymentConfiguration:updatedArray,
                                paymentFrequency: dataToSend.paymentFrequency.toLowerCase(),
                                payerType:dataToSend.payerType,
                                description:dataToSend.description,
                                bankAccountId:dataToSend.bankAccountId
                            }
                        }/>
                        
                    </div>
        </div>
        <br/>

        

    </div>
  )
}




function ProprtyAvailableForListWidgetDues(props) {

    // State to store the values of each input field
    const initialValues = props.initialValues
    const [values, setValues] = useState(initialValues);
  
    // Handler function to update the value of a specific input field
    const handleInputChange = (index, newValue) => {
      const newValues = [...values];
    //   newValues[index].amount = parseFloat(newValue);
      newValues[index].amount = newValue;
      setValues(newValues);
        
    };
  
  return (
    <div>
        {values &&
            values.map((data,index)=>
                <Pane display="flex" 
                    style={{
                    display:"flex"  
                    }}
                >
                    
                    <Pane 
                        
                        background="purpleTint" 
                        // borderColor="purpleTint"
                        // borderWidth="1"
                        // borderStyle="solid"
                        borderRadius={5} 
                        flex={1}  
                        alignItems="center" 
                        display="flex" 
                        justifyContent="space-between"
                        paddingRight="10px"
                        paddingLeft="10px"
                        height="50px"
                        
                    >
                   
                    
                        <Heading size={300}>{data.type.replace(/_/g, ' ')}</Heading>
                        <Heading size={300}>{data.numberOfRooms}</Heading>
                    {/* </div> */}
                    </Pane>
                    <Pane paddingLeft={10} style={{
                        width:"100px"
                    }}>
                        <AppInputField
                            type="text" 
                         key={index}
                         value={data.amount} 
                         onChange={(e) => handleInputChange(index, e.target.value)
                        }
                        />
                    </Pane>
                </Pane>
            )
        }
    </div>
  )
}








function AddDuesSubmitButton(props) {
const history = useHistory()
const [addDuesForAll, { loading }] = useMutation(DUE_CREATE);
const dattaToSend=props.dataTo;
const accesTokenValue = Cookies.get('userAccessToken');

const handleSubmit=()=>{
    // e.preventDefault()
    // console.log(dattaToSend)
    addDuesForAll({
            variables:dattaToSend,
            context: {
            headers: {
                Authorization: `Bearer ${accesTokenValue}`,
            },
        },
    })
    .then((response) => {
        toaster.notify("Dues added successfully.")
        history.push(`/dues`)
        window.location.reload()
    })
    .catch((error) => {
        // console.log("sdd==",error);
        toaster.danger(error.message)
});
}
  return (
    <div>
        <AppInputFieldBtn className='' disabled={loading}
            onClick={()=>handleSubmit()}
        >
            Create
        </AppInputFieldBtn>
    </div>
  )
}
